<template>
  <div>
    <v-card class="rounded-lg elevation-3 overflow-hidden">
      <!-- Toolbar Header -->
      <v-toolbar height="58" color="secondary" dark flat class="px-3">
        <div class="d-flex align-center">
          <v-icon left>mdi-cached</v-icon>
          <span class="text-h6 font-weight-medium">
            {{ Titulo || "Neumáticos Retirados para Reencauche" }}
          </span>
          <v-chip
            small
            color="white"
            text-color="secondary"
            class="font-weight-bold ml-3 px-3 elevation-1"
            style="font-size: 0.95rem; height: 32px"
          >
            <v-icon left size="18" color="secondary">mdi-counter</v-icon>
            {{ ItemTotal || (Items ? Items.length : 0) }}
          </v-chip>
        </div>

        <v-spacer></v-spacer>

        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-1 btn-circle-tooltip"
              icon
              dark
              :href="global.helpdesk_url + 'nuema_retir_reencauche'"
              target="_blank"
              v-on="on"
            >
              <v-icon size="25" color="amber lighten-2"
                >mdi-help-circle-outline</v-icon
              >
            </v-btn>
          </template>
          <span>Panel de ayuda</span>
        </v-tooltip>
      </v-toolbar>

      <div class="pa-4 pb-2">
        <!-- Barra de alerta informativa y leyenda -->
        <v-alert
          colored-border
          border="top"
          color="orange darken-3"
          elevation="2"
          icon="mdi-information-outline"
          class="orange lighten-5 rounded-lg mb-4 pa-3 alert-icon-leyenda"
          style="width: 100%"
        >
          <v-row dense class="align-center">
            <v-col cols="12">
              <div class="d-flex align-center flex-wrap pt-2">
                <span class="grey--text text--darken-4 body-2">
                  Los neumáticos que se listan aquí se encuentran retirados para
                  reencauche y <strong>se deben desinstalar</strong> del
                  vehículo correspondiente.
                </span>
              </div>
            </v-col>

            <v-col cols="12">
              <div class="d-flex align-center flex-wrap" style="gap: 8px">
                <div class="d-flex align-center">
                  <v-btn
                    height="22"
                    width="22"
                    color="green"
                    fab
                    x-small
                    dark
                    class="mr-2 elevation-1 flex-shrink-0"
                  >
                    <v-icon x-small>mdi-currency-usd</v-icon>
                  </v-btn>
                  <div>
                    <span
                      class="green--text text--darken-4 font-weight-bold text-caption mr-1"
                      >Costo:</span
                    >
                    <span
                      class="grey--text text--darken-4 text-caption font-weight-medium"
                      >Ver y registrar el reporte de costos de reencauche del
                      neumático.</span
                    >
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-alert>

        <!-- Barra de Control: Búsqueda y Botones -->
        <div
          class="d-flex align-center justify-space-between flex-wrap gap-2 mb-3"
        >
          <div class="search-field flex-grow-1 mr-md-3">
            <v-text-field
              v-model="search"
              outlined
              dense
              single-line
              hide-details
              prepend-inner-icon="mdi-magnify"
              clearable
              placeholder="Buscar por serie, marca, modelo, vehículo..."
              class="rounded-lg"
            ></v-text-field>
          </div>

          <div class="d-flex align-center flex-wrap gap-2 mt-2 mt-md-0">
            <v-btn
              v-if="Excel"
              color="success"
              dark
              height="38"
              class="px-4 font-weight-bold elevation-1 text-none rounded-lg"
              @click="DescargarExcel()"
            >
              <v-icon left size="20">mdi-file-excel-box</v-icon>
              Exportar Excel
            </v-btn>

            <v-btn
              v-if="Crear"
              color="primary"
              dark
              height="38"
              class="px-4 font-weight-bold elevation-1 text-none rounded-lg ml-2"
              @click="nuevoItem()"
            >
              <v-icon left size="20">mdi-plus-circle</v-icon>
              Nuevo
            </v-btn>
          </div>
        </div>
      </div>

      <!-- Tabla Responsiva -->
      <div class="table-responsive-wrapper">
        <v-data-table
          dense
          :headers="Cabecera"
          :items="Items"
          :items-per-page="10"
          :search="search"
          :loading="loading"
          class="elevation-0 modern-table"
          loading-text="Cargando neumáticos en reencauche... Por favor, espere"
          no-data-text="No hay datos disponibles"
          :footer-props="{
            'items-per-page-text': 'Resultados por página:',
            'page-text': '{0}-{1} de {2}',
          }"
        >
          <!-- Opciones / Acciones -->
          <template v-slot:[`item.acciones`]="{ item }">
            <div class="d-flex align-center">
              <v-tooltip bottom v-if="item.estado == 3">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    height="24"
                    width="24"
                    color="orange"
                    fab
                    x-small
                    dark
                    class="action-btn elevation-1"
                    @click="gomantvehi(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon x-small>mdi-arrow-right-bottom-bold</v-icon>
                  </v-btn>
                </template>
                <span>Redireccionar al vehículo</span>
              </v-tooltip>

              <v-tooltip bottom v-else-if="item.estado == 4">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    height="24"
                    width="24"
                    color="green"
                    fab
                    x-small
                    dark
                    class="action-btn elevation-1"
                    @click="costos(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon x-small>mdi-currency-usd</v-icon>
                  </v-btn>
                </template>
                <span>Reporte de costo</span>
              </v-tooltip>
            </div>
          </template>

          <!-- N° Serie destacado -->
          <template v-slot:[`item.num_serie`]="{ item }">
            <span class="font-weight-bold font-mono text--primary">
              {{ item.num_serie }}
            </span>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import router from "@/router";
import axios from "axios";
import global from "@/global";
import exportFromJSON from "export-from-json";

export default {
  props: [
    "Titulo",
    "Cabecera",
    "loading",
    "Items",
    "Item",
    "ItemTotal",
    "Excel",
    "Crear",
  ],
  data() {
    return {
      costo: {},
      global: global,
      search: "",
      mostrarIcono: true,
    };
  },
  computed: {
    ...mapState("neumatico", ["TipoCambio"]),
  },
  methods: {
    ...mapActions("neumatico", ["asignarObjetoNeumatico"]),

    costos: function (item) {
      this.asignarObjetoNeumatico(item);
      router.push("/neumaticoreportecosto/" + item.id);
    },

    gomantvehi(item) {
      const id_vehiculo =
        typeof item === "object" && item !== null
          ? (item.neumatico_historial &&
              (item.neumatico_historial.id_vehiculos ||
                (item.neumatico_historial.vehiculos &&
                  item.neumatico_historial.vehiculos.id))) ||
            item.id_vehiculo ||
            item.vehiculo_id
          : item;

      if (!id_vehiculo) {
        console.warn("No se encontró id_vehiculo en el neumático", item);
        return;
      }
      this.$router.push({ path: `/ubicaciontemporal` });
      setTimeout(() => {
        this.$router.push({ path: `/vehiculo/instalacion/${id_vehiculo}` });
      }, 10);
    },

    DescargarExcel() {
      const data = this.Items;
      const nombreArchivo = "neumaticos_en_reencauche";
      const exportType = exportFromJSON.types.xls;
      exportFromJSON({ data, nombreArchivo, exportType });
    },

    nuevoItem() {
      this.$emit("nuevo");
    },
  },
};
</script>

<style scoped>
.modern-table {
  border-top: 1px solid #e2e8f0;
}

.modern-table ::v-deep thead tr:not(.v-data-table__progress) th {
  background-color: #424242 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  font-size: 0.8rem !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  white-space: nowrap;
  border-bottom: 2px solid #212121 !important;
  border-right: 1px solid rgba(255, 255, 255, 0.12) !important;
  padding: 10px 14px !important;
  height: 42px !important;
}

.modern-table
  ::v-deep
  thead
  tr:not(.v-data-table__progress)
  th
  .v-data-table-header__icon {
  color: #ffffff !important;
}

.modern-table ::v-deep .v-data-table__progress th {
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  padding: 0 !important;
  height: auto !important;
}

.modern-table ::v-deep .v-data-table__empty-wrapper td {
  background: transparent !important;
  background-color: transparent !important;
}

.modern-table ::v-deep td {
  font-size: 0.85rem !important;
  padding: 8px 14px !important;
  border-bottom: 1px solid #f1f5f9 !important;
  vertical-align: middle;
}

.modern-table ::v-deep tbody tr:hover {
  background-color: #f8fafc !important;
  transition: background-color 0.15s ease-in-out;
}

.modern-table ::v-deep .v-data-footer {
  border-top: 1px solid #e2e8f0;
  background-color: #f8fafc;
  font-size: 0.82rem;
  padding: 8px 16px;
}

.table-responsive-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive-wrapper::-webkit-scrollbar {
  height: 6px;
}

.table-responsive-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.search-field {
  max-width: 360px;
  min-width: 220px;
}

@media (max-width: 768px) {
  .search-field {
    max-width: 100%;
    width: 100%;
  }
}

.action-btn {
  transition: transform 0.18s ease-in-out, box-shadow 0.18s ease-in-out;
}

.action-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2) !important;
}

.font-mono {
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier,
    monospace;
}

.alert-icon-leyenda ::v-deep .v-alert__wrapper {
  align-items: center !important;
}

.alert-icon-leyenda ::v-deep .v-alert__icon {
  align-self: center !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.gap-2 {
  gap: 8px;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip ::v-deep .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
}

.btn-circle-tooltip ::v-deep .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}
</style>
